import { PlayerStatValueType } from '@Global/apollo/types';

export enum ENftLeague {
  'BEGINNER' = 'BEGINNER',
  'LITE' = 'LITE',
  'AMATEUR' = 'AMATEUR',
  'SEMIPRO' = 'SEMIPRO',
  'PRO' = 'PRO',
  'LEGENDARY' = 'LEGENDARY',
  'MIXZONE' = 'MIXZONE',
}

export enum EGameLabel {
  RUSSIA = 'RUS',
  EUROPA_LEAGUE = 'EURL',
  CONFERENCE_LEAGUE = 'CONFL',
  TOP5 = 'TOP5',
  AMATEUR = 'AMATEUR',
  PRO = 'PRO',
  PREMIUMM = 'PREMIUM',
  EPL = 'EPL',
  SERIE_A = 'SERIE_A',
  LALIGA = 'LALIGA',
  LIGA1 = 'LIGA1',
  BUNDESLIGA = 'BUNDESLIGA',
  CL = 'CL',
  BRA1 = 'BRA1',
  EURO2024 = 'EURO2024',
  WC2022 = 'WC2022',
  PREMIUML = 'PREMIUM+',
  PREMIUMS = 'PREMIUMS',
  MLS = 'MLS',
  MAIN = 'MAIN',
  WINLINE = 'winline',
}

export const tournamentsLabels = [
  EGameLabel.TOP5,
  EGameLabel.EPL,
  EGameLabel.RUSSIA,
  EGameLabel.SERIE_A,
  EGameLabel.LALIGA,
  EGameLabel.LIGA1,
  EGameLabel.BUNDESLIGA,
  EGameLabel.BRA1,
  EGameLabel.CL,
  EGameLabel.EUROPA_LEAGUE,
  EGameLabel.CONFERENCE_LEAGUE,
  EGameLabel.EURO2024,
  EGameLabel.MLS,
  EGameLabel.WINLINE,
];

// export type TWalletProviderWithOtherWallet = typeof WalletProvider[keyof typeof WalletProvider];

// Based on WalletProvider
export type WalletProviders =
  | 'TRUST'
  | 'NEOCRYPTO'
  | 'TON_WALLET'
  | 'CRYPTO_EXCHANGES'
  | 'STARS'
  | 'OTHER_WALLET'
  | 'TONSPACE_WALLET'
  | 'TELEGRAM_WALLET'
  | 'TONKEEPER';
// it is old providers but it could be return
// | 'TONKEEPER'
// | 'TONSPACE'
// | 'TONSPACE_WALLET'
// | 'TELEGRAM_WALLET'

export const PRODUCTION_BOT_URL = 'https://t.me/FanTonGameBot';

export const QA_BOT_URL = 'https://t.me/FantonGameQaBot';

export const STARTPATH_QUERY_PARAM_NAME = 'startPath';

export const ACTION_QUERY_PARAM_NAME = 'action';

export const COMMIT_TEAM_ACTION = 'commitTeam';

export const GAME_ID_QUERY_PARAM_NAME = 'gameId';

export const PAYMENT_CURRENCY_QUERY_PARAM_NAME = 'currency';

export const BASE_URL = 'https://app.fan-ton.com';

enum PlayerStatValueTypeExtension {
  Cleansheet = 'CLEANSHEET',
  AveragePoints = 'AVERAGE_POINTS',
  DefensiveContributions = 'DEFENSIVE_CONTRIBUTIONS',
  BestPlayer = 'BEST_PLAYER',
}

export const ExtendedPLayerStatValueType = {
  ...PlayerStatValueType,
  ...PlayerStatValueTypeExtension,
} as const;

export type TExtendedPLayerStatValueTypeKey = keyof typeof ExtendedPLayerStatValueType;

export type TExtendedPLayerStatValueTypeValue = typeof ExtendedPLayerStatValueType[TExtendedPLayerStatValueTypeKey];

export const IS_LOCAL = Boolean(process.env.REACT_APP_IS_LOCAL);

export const PVP_ROUTES: string[] = [];
// export const PVP_ROUTES: string[] = [EAppRoute.PVP_GAMES, EAppRoute.MY_PVP_GAMES];

export const GAME_TO_JUMP_ON_START_ID = 'GAME_TO_JUMP_ON_START_ID';
export const GAME_TO_JUMP_ON_SUBMISSION_TASKS_ID = 'GAME_TO_JUMP_ON_SUBMISSION_TASKS_ID';
export const LOOTBOXES_INTRO_WATCHED = 'LOOTBOXES_INTRO_WATCHED';
export const LOOTBOXES_INTRO_WATCHED_CARDS = 'LOOTBOXES_INTRO_WATCHED_CARDS';

export const FREE_FIRST_TEAM = 'free_first_team';
export const ANY_PLAYER_LABEL = 'any_player';
export const ALL_PLAYERS_LABEL = 'all_players';
export const ANY_PLAYER_ONBOARDING_SKIPPED = 'any_player_onboarding_skipped';
export const ANY_PLAYER_ONBOARDING_PASSED = 'any_player_onboarding_passed';

export const CAPPED_LABEL = 'capped';

export const DEFAULT_RAKE = 0.15;
